// customers.country and customers.country_code must always say the same thing: CDS / customs and the Sage import read country_code, the
// screens used to show country. Before this, the Companies form wrote only `country` (as free text) and the Address Book wrote both, copying
// whatever was in `country` into country_code, so 223 companies had a country but no code. ONE rule for both forms (and the database
// trigger in migration 20261106a does the same for any other writer): a country is stored as its ISO 3166-1 alpha-2 code in BOTH columns.
// Text that cannot be turned into a code safely is never guessed: the form refuses to save it and says so.
// Run: node --test --experimental-strip-types src/lib/customerCountry.test.ts
import { isValidIsoCountry } from './cds/countries.ts'
import { resolveCountryText } from './countries.ts'

export type CountryFields = { ok: true; country: string | null; country_code: string | null } | { ok: false; text: string }

export function countryFieldsForSave(raw: string | null | undefined): CountryFields {
  const text = (raw ?? '').trim()
  if (!text) return { ok: true, country: null, country_code: null }
  if (/^[A-Za-z]{2}$/.test(text) && isValidIsoCountry(text)) { const c = text.toUpperCase(); return { ok: true, country: c, country_code: c } }
  const code = resolveCountryText(text).code
  return code ? { ok: true, country: code, country_code: code } : { ok: false, text }
}

// What the country picker should hold when a stored value is opened: the ISO code when the stored text maps to one safely
// ("China", "United Kingdom", "UK" -> CN / GB), otherwise the stored text as it is (the picker shows it as unset and the form warns).
export function countryForForm(raw: string | null | undefined): string {
  const r = countryFieldsForSave(raw)
  return r.ok ? (r.country ?? '') : (raw ?? '')
}

export const countryNotValidMessage = (text: string) =>
  `Country "${text}" is not a country the system recognises. Choose the country from the list (it fills both the country and the country code).`
